import React from "react";
import { Box, Skeleton, Typography, Container, Grid } from "@mui/material";

const SwapRebalanceFinalSkeleton = () => (
  <Container disableGutters maxWidth="100%" sx={{ marginTop: 2, flex: 1, display: "flex", flexDirection: "column", minHeight: 0, overflow: "hidden" }}>
    <Grid container spacing={2} alignItems="stretch" sx={{ flex: 1, minHeight: 0 }}>
      <Grid size={{ xs: 12 }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <Box sx={{ width: "40%" }}>
            <Box
              sx={{
                marginBottom: 1,
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <Skeleton variant="text" width={200} height={32} />
              <Skeleton variant="rectangular" width={120} height={36} sx={{ mb: 1 }} />
            </Box>
          </Box>
        </Box>
      </Grid>
      <Grid size={{ xs: 12 }} sx={{ display: "flex", flexDirection: "column", flex: 1, minHeight: 0 }}>
        {/* Success Alert Skeleton */}
        <Skeleton variant="rectangular" width={500} height={48} sx={{ mb: 2, flexShrink: 0 }} />
        {/* Table Skeleton */}
        <Box sx={{ display: "flex", flexDirection: "row", width: "60%", flex: 1, minHeight: 0 }}>
          <Box sx={{ width: "100%", flex: 1, minHeight: 0, display: "flex", flexDirection: "column", overflow: "hidden" }}>
            {/* Table Header */}
            <Box sx={{ display: "flex", mb: 1 }}>
              <Skeleton variant="text" width={120} height={28} sx={{ mr: 2 }} />
              <Skeleton variant="text" width={160} height={28} sx={{ mr: 2 }} />
              <Skeleton variant="text" width={120} height={28} sx={{ mr: 2 }} />
              <Skeleton variant="text" width={120} height={28} />
            </Box>
            {/* Table Rows */}
            <Box sx={{ flex: 1, minHeight: 0, overflow: "hidden" }}>
            {[...Array(8)].map((_, i) => (
              <Box key={i} sx={{ display: "flex", mb: 1 }}>
                <Skeleton variant="text" width={120} height={24} sx={{ mr: 2 }} />
                <Skeleton variant="text" width={160} height={24} sx={{ mr: 2 }} />
                <Skeleton variant="text" width={120} height={24} sx={{ mr: 2 }} />
                <Skeleton variant="text" width={120} height={24} />
              </Box>
            ))}
            </Box>
          </Box>
        </Box>
      </Grid>
    </Grid>
  </Container>
);

export default SwapRebalanceFinalSkeleton; 